import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
  domain="snapcourse.us.auth0.com"
  clientId="Ub0t2WwFqeOQVDDv9Ex41jIM1fy2OrVx"
  authorizationParams={{
    redirect_uri: window.location.origin,
    audience: "https://snapcourse.us.auth0.com/api/v2/",
    scope: "openid profile email read:current_user update:current_user_metadata"
  }}
>

    <App />
    </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
